<template>
  <body>
    <ModalIdiomas :idiomas="idiomas" v-show="modalIdiomas"
      @cerrar="cerrarModal"
      @recargar="recargarIdiomas"
      @AddIdioma="otroIdioma"/>
    <aside class="Blk-1">
    </aside>
    <aside class="Blk-2">
      <article class="Form">
        <div class="Blk-Campo">
          <p id="titReg">Palabras registradas</p>
          <select name="palabras" id="" class="campo"
            :disabled = 'habBotAndCamp.hab'
            v-model="palabraSel" @change.prevent="mostrarTraduccPalabra(palabraSel.bloque)">
            <option v-for="palabra in palabras"
              :key="palabra._id"
              :value="palabra">
              {{palabra.palabra}}
            </option>
          </select>
        </div>
          <div class="Blk-Campo" id="I-P">
            <p>Idioma/Palabra</p>
            <select name="idiomas" id="" class="campo"
            :disabled = '!habBotAndCamp.hab'
            v-model="idiomaSel">
            <option v-for="idioma in idiomas"
              :key="idioma"
              :value="idioma">
              {{idioma.idioma}}
            </option>
            </select>
            <input type="text" class="campo" ref="palabraES"
              :disabled = '!habBotAndCamp.hab'
              v-model.trim="palabraN">
            <button class="botAut" id="BtnMas" @click.prevent="addPareja" :disabled = '!habBotAndCamp.hab'>+</button>
          </div>
        <form @change="cambioBloqueTraducc">
          <div class="Blk-Campo">
            <div class="tabla" v-for="(pareja, index) in bloqueTr" :key="index">
              <p id="pFict"></p>
              <p class="campoI">{{pareja.idioma}}</p>
              <p class="campoP">{{pareja.palabra}}</p>
              <button class="botAut" @click.prevent="borraPareja(index)" v-show = habBotAndCamp.hab> - </button>
            </div>
          </div>
          <div class="Blk-Campo">
            <p>Comentario</p>
            <textarea name="coment" id="indice"  class="campo" rows="6"
              :disabled = '!habBotAndCamp.hab'
              spellcheck="false"
              v-model.trim="commentTr.comentario">
            </textarea>
          </div>
        </form>
      </article>
      <aside class="Btns">
        <BotonesCRUD
        :desacMas="!habBotAndCamp.actMas"
        :desacEdit="!habBotAndCamp.actEdi"
        :desacMenos="!habBotAndCamp.actMen"
        :desacSave="!habBotAndCamp.actSav"
        @nuevo="nuevaTraducc"
        @editar="editar"
        @del="borrar"
        @save="saveTraducc"
        />
        <div class="">
          <button class="NewId" @click="nuevoIdioma" :disabled = '!habBotAndCamp.hab'>Nuevo idioma</button>
        </div>
      </aside>
    </aside>
  </body>
</template>

<script>
import { mapState } from 'vuex' // en Computed está ...mapState(['usuarioEnSesion'])
import BotonesCRUD from '../components/BotonesCRUD.vue'
import ModalIdiomas from '../components/ModalIdiomas.vue'
import axios from 'axios'
export default {
  name: 'FormDiccionario',
  components: { BotonesCRUD, ModalIdiomas },
  created () {
    this.URLbase = process.env.VUE_APP_ROOT_API
    this.token = this.usuarioEnSesion.tokenUser
    this.getIdiomas()
    this.getPalabras()
    this.getComments()
    this.activaModo('INI')
  },
  data () {
    return {
      palabraN: '',
      palabras: [],
      idiomaSel: '',
      bloqueTr: [],
      bloqueTrBkUp: [],
      bloqueEd: 0,
      comments: [],
      commentTr: {},
      commentTrBkUp: {},
      ultimoBloque: 0,
      modalIdiomas: false,
      palabraSel: [],
      idiomas: [],
      habBotAndCamp: {
        actMas: false,
        actEdi: false,
        actMen: false,
        actSav: false,
        hab: false
      },
      IsModoSalirMas: false,
      IsModoSalirEdi: false,
      URLbase: '',
      token: ''
    }
  },
  methods: {
    calcUltBloque (array) {
      let maxTemp = 0
      for (let i = 0; i < array.length; i++) {
        const a = array[i].bloque
        if (a > maxTemp) { maxTemp = a }
      }
      this.ultimoBloque = maxTemp
    },
    mostrarTraduccPalabra (bloque) {
      this.bloqueTr = this.palabras.filter(e => e.bloque === bloque)
      this.commentTr = this.comments.find(e => e.bloque === bloque)
      this.activaModo('Sel')
      this.bloqueEd = bloque
    },
    cambioBloqueTraducc () {
      if (this.IsModoSalirMas && this.minDataTraducc) {
        this.activaModo('MASs')
      }
      if (this.IsModoSalirEdi && this.minDataTraducc) {
        this.activaModo('EDIs')
      }
    },
    async getIdiomas () {
      try {
        const url = `${this.URLbase}/idiomas/listIdiomas`
        const res = await fetch(url)
        this.idiomas = await res.json()
      } catch (error) {
        alert(error)
      }
    },
    async getPalabras () {
      try {
        const url = `${this.URLbase}/palabras/listPalabras`
        const res = await fetch(url)
        this.palabras = await res.json()
      } catch (error) {
        alert(error)
      }
    },
    async getComments () {
      try {
        const url = `${this.URLbase}/comments/listComments`
        const res = await fetch(url)
        this.comments = await res.json()
      } catch (error) {
        alert(error)
      }
    },
    recargarIdiomas () {
      this.getIdiomas()
    },
    otroIdioma () {

    },
    nuevoIdioma () {
      this.modalIdiomas = true
    },
    cerrarModal () {
      this.modalIdiomas = false
    },
    async borrar () {
      if (this.bloqueTr.length > 1) {
        this.alertJoa('Usa el modo edición, para eliminar una o varias palabra de un conjunto de traducciones, pero no la última.', 'W')
      } else {
        const response = await this.$root.alertJoa(
          'Estás a punto de borrar el registro de esta palabra. Esta acción no puede revertirse ¿Quieres continuar?',
          'W', 'C')
        if (response === 'borrar') {
          const url = `${this.URLbase}/palabras/deletePalabra`
          const palabraId = { _id: this.palabraSel._id, bloque: this.palabraSel.bloque }
          try {
            const result = await axios.post(url, palabraId, {
              headers: {
                authorization: this.token
              }
            })
            // console.log('Resultado:', result.status)
            switch (result.status) {
              case 200:
                this.blanquear()
                this.activaModo('INI')
                this.alertJoa('¡Registro borrado con éxito!', 'S')
                this.getPalabras()
                this.getComments()
                break
              case 500:
                this.alertJoa('Error al borrar registro, intenta otra vez', 'E')
                break
              default:
                this.alertJoa('Algo salió mal, intenta otra vez', 'E')
            }
          } catch (error) {
            // console.error(error)
            this.alertJoa('Error al borrar registro, intenta otra vez', 'E')
          }
        }
      }
    },
    nuevaTraducc () {
      this.calcUltBloque(this.palabras)
      this.IsModoSalirMas = !this.IsModoSalirMas
      if (this.IsModoSalirMas) {
        this.bloqueTrBkUp = JSON.parse(JSON.stringify(this.bloqueTr))
        this.palabraSelBkUp = JSON.parse(JSON.stringify(this.palabraSel))
        this.commentTrBkUp = JSON.parse(JSON.stringify(this.commentTr))
        this.blanquear()
        this.activaModo('MAS')
      } else {
        this.palabraSel = this.palabraSelBkUp
        this.palabraN = ''
        this.idiomaSel = {}
        if (this.palabraSel.palabra) {
          this.bloqueTr = JSON.parse(JSON.stringify(this.bloqueTrBkUp))
          this.commentTr = JSON.parse(JSON.stringify(this.commentTrBkUp))
          this.activaModo('Sel')
        } else {
          this.blanquear()
          this.activaModo('INI')
        }
      }
    },
    blanquear () {
      this.bloqueTr = []
      this.commentTr = {}
      this.palabraN = ''
      this.idiomaSel = {}
      this.palabraSel = {}
    },
    addPareja () {
      if (this.idiomaSel.idioma && this.palabraN) {
        if (this.IsModoSalirMas) {
          const bloque = this.ultimoBloque + 1
          this.bloqueTr.push({ idioma: this.idiomaSel.idioma, palabra: this.palabraN, bloque: bloque })
          if (this.minDataTraducc) {
            this.activaModo('MASs')
          }
        } else {
          const bloque = this.bloqueEd
          this.bloqueTr.push({ idioma: this.idiomaSel.idioma, palabra: this.palabraN, bloque: bloque })
          if (this.minDataTraducc) {
            this.activaModo('EDIs')
          }
        }
      }
      this.palabraN = ''
      this.idiomaSel = {}
    },
    borraPareja (pos) {
      if (this.bloqueTr.length > 1) {
        this.bloqueTr.splice(pos, 1)
        if (this.minDataTraducc) {
          this.activaModo('EDIs')
        }
      } else {
        this.alertJoa('En modo edición, no puedes eliminar todas las palabras. Usa el botón Eliminar.', 'W')
      }
    },
    editar () {
      this.IsModoSalirEdi = !this.IsModoSalirEdi
      // Si es modo edición, hace copia de los datos actuales por si se cancela
      if (this.IsModoSalirEdi) {
        this.bloqueTrBkUp = JSON.parse(JSON.stringify(this.bloqueTr))
        this.palabraSelBkUp = JSON.parse(JSON.stringify(this.palabraSel))
        this.commentTrBkUp = JSON.parse(JSON.stringify(this.commentTr))
        this.activaModo('EDI')
      } else {
        // Si se cancela, restaura los valores previos
        this.bloqueTr = JSON.parse(JSON.stringify(this.bloqueTrBkUp))
        this.palabraSel = this.palabraSelBkUp
        this.commentTr = JSON.parse(JSON.stringify(this.commentTrBkUp))
        this.activaModo('Sel')
      }
    },
    async saveTraducc () {
      try {
        const url = `${this.URLbase}/palabras/save`
        if (this.IsModoSalirMas) { this.commentTr.bloque = this.ultimoBloque + 1 }
        this.bloqueTr.unshift(this.commentTr)
        const bloqueTr = this.bloqueTr
        axios.post(url, bloqueTr)
          .then(result => {
            switch (result.data) {
              case 'error':
                this.alertJoa('Error al guardar, intenta otra vez', 'E')
                break
              case 'success':
                this.alertJoa('Datos guardados con éxito!', 'S')
                break
            }
            this.getPalabras()
            this.getComments()
          })
      } catch (error) {
        alert(error)
      }
      this.IsModoSalirMas = false
      this.IsModoSalirEdi = false
      this.blanquear()
      this.activaModo('INI')
    },
    activaModo (modo) {
      switch (modo) {
        case 'INI':
          this.confModo = [1, 0, 0, 0, 0]
          break
        case 'Sel':
          this.confModo = [1, 1, 1, 0, 0]
          break
        case 'MAS':
          this.confModo = [1, 0, 0, 0, 1]
          break
        case 'MASs':
          this.confModo = [1, 0, 0, 1, 1]
          break
        case 'EDI':
          this.confModo = [0, 1, 0, 0, 1]
          break
        case 'EDIs':
          this.confModo = [0, 1, 0, 1, 1]
          break
      }
      let i = 0
      for (const key in this.habBotAndCamp) {
        this.confModo[i] === 0
          ? this.habBotAndCamp[key] = false
          : this.habBotAndCamp[key] = true
        i++
      }
    }
  },
  computed: {
    minDataTraducc () {
      return (this.bloqueTr.length > 0)
    },
    ...mapState(['usuarioEnSesion'])
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
body {
  width: 100vw;
  height: 82vh;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}
aside.Blk-1 {
  width: 20%;
  background-color: var(--az-cl-tr08);
  border: solid 0.5px var(--az-cl-tr08);
}
.constru{
  margin-top: 35px;
  width:80%;
  justify-self: center;
  /* box-shadow: rgb(53, 52, 52) 5px 5px 7px; */
}
aside.Blk-2 {
  width: 80%;
  display: grid;
  grid-template-columns: 75% 25%;
  background-color: var(--gr-fo-for);
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 1.5%;
}
article.Form {
  /* color: darkslategray; */
  padding-top: 20px;
}
.Btns {
  /* display: grid; */
  padding-left: 0px;
  padding-top: 20px;
  /* position: fixed;
  width:15%;
  top:130px;
  right:10px; */
}
.NewId{
  margin-top: 55px;
}
.formIndTel{
  display:none;
}
.Blk-Campo{
  width: 100%;
  /* flex:20; */
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 4px;
}
.Blk-Campo p {
  color: black;
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  padding-left: 18px;
  max-width: 90px;
  min-width: 90px;
  margin-bottom: 2px;
  line-height: 98%;
}
.campo{
  height: auto;
  min-height: 26px;
  width: auto;
  min-width: 70px;
  /* margin-left: 10px; */
  padding-left: 8px;
  background-color: var(--gr-fo-cam);
  border: solid 0.5px rgb(199, 191, 188);
  border-radius: 3px;
  font-size: 15px;
  color: var(--tx-cam);
  flex: 2;
  text-align: left;
}
.campo:focus{
  outline-color: var(--az-ico);
}
#I-P{
  margin-bottom: 20px;
}
.tabla{
  display:flex;
}
.campoI, .campoP{
  color: black;
  margin-right: 5px;
  padding: 5px 25px;
  border: solid 1px rgb(96, 96, 96);
}
.botAut{
  height: auto;
  min-height: 26px;
  width: 26px;
  font-size: 18px;
  border: none;
  background-color: rgb(57, 137, 207);
  color: white;
  border-radius: 3px;
  font-weight: 800;
  line-height: 1.2;
}
.botAut:hover{
  cursor: pointer;
  background-color: rgb(37, 109, 172);
}
.botAut:disabled{
  cursor: pointer;
  background-color: rgb(175, 212, 245);
}
.NewId{
  background-color: rgb(57, 177, 207);
  color: white;
  border-radius: 3px;
  border: none;
  padding: 3px 6px;
}
.NewId:hover{
  cursor: pointer;
  background-color: rgb(33, 145, 173);
}
.NewId:disabled{
  cursor: pointer;
  background-color: rgb(148, 200, 212);
}

#titReg{
  font-weight: bold;
}
@media screen and (max-width: 600px){
  body {
    width: 100vw;
    height: 83vh;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .Blk-1{
    display: none;
  }
  aside.Blk-2 {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    align-items: stretch;/*horizontal*/
    justify-content:flex-end; /*vertical*/
    height: 80vh;
  }
  .Form {
    padding-top: 10px;
    overflow: scroll;
  }
  .Blk-Campo {
    flex-direction: column;
    /* align-items:flex-start; */
    align-items:stretch;
  }
  .Blk-Campo p{
    max-width: 190px;
  }
  .campo{
    /* width: 100% no funciona, el ancho se controla con align-items: strech en .Blk-Campo*/
    margin: 0 2% 0 2%;
  }
  #pFict{
    display: none;
  }
  .campoI{
    width: 25vw;
    padding: 5px 12px;
    margin-left: 2.5%
  }
  .campoP{
    width: 40vw;
    padding: 5px 15px;
  }
  #nombreSeparata{
    max-width: 96%;
  }
  .Btns {
    padding: 0 2.5% 2% 2.5%;
  }
  .NewId{
    margin-top: 15px;
  }
  .formIndTel{
    display: block;
    align-self: end;
    margin-right: 2%;
  }
  textarea {
    resize: none;
  }
  .botonesAut{
    align-self: flex-end;
    margin: 2.5%;
  }
  #BtnMas{
    margin: 2% 0 0 2.5%;
  }
  .imagen2{
    display:inline-flex;
    width: 65%;
    margin-top: 5px;
    margin-bottom:15px;
    justify-self: center;
    box-shadow: rgb(53, 52, 52) 5px 5px 7px;
  }
}
</style>
